module.exports = __webpack_public_path__ + "media/images/flags/kr-939387c390531d01a6877e2f6f272f56.svg";